<app-simple-responsive-frame>
    <div class="welcome">
        <div class="welcome-content">
            <div class="welcome-copy">
                <h3 style="font-weight: 100;">Paso 2</h3>
                <h1>Un par de detalles más.</h1>
                <h3 style="font-weight: 100;">Ahora agrega más detalles para que tu propiedad
                    tenga más posibilidades de ser encontrada.</h3>
            </div>
        </div>
        <!-- Columna derecha con las cartas apiladas -->
        <div class="welcome-images">
            <img class="image image-1" [src]="'assets/layout/images/home/1.png'" alt="Image 1">
            <img class="image image-2" [src]="'assets/layout/images/home/2.png'" alt="Image 2">
        </div>
    </div>

    <app-page-navigation-bar
        [value]="40"
        [type]="'complete'"
        [previousPageURL]="previousUrl"
        [nextPageURL]="nextUrl"
        [flowMode]="mode"
        [stepKey]="'second'"
        (goNext)="handleNextStep()"
        (goPrevious)="handlePreviousStep()">
    </app-page-navigation-bar>
</app-simple-responsive-frame>
